export const USER_ROLES = {
  OPERATOR: 'operator',
};

export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const USER_STATUS_ARRAY = Object.values(USER_STATUS);

export const USER_STATUS_LABELS = {
  [USER_STATUS.ACTIVE]: 'Active',
  [USER_STATUS.INACTIVE]: 'Inactive',
};

export const ROOM_TYPES = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  SILENT: 'silent',
};

export const ROOM_TYPES_ARRAY = Object.values(ROOM_TYPES);

export const ROOM_TYPE_LABELS = {
  [ROOM_TYPES.PUBLIC]: 'Public Area',
  [ROOM_TYPES.PRIVATE]: 'Private Room',
  [ROOM_TYPES.SILENT]: 'Silent Room',
};

export const SESSION_STATUS = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const SESSION_STATUS_ARRAY = Object.values(SESSION_STATUS);

export const SESSION_STATUS_LABELS = {
  [SESSION_STATUS.ACTIVE]: 'Active',
  [SESSION_STATUS.COMPLETED]: 'Completed',
  [SESSION_STATUS.CANCELLED]: 'Cancelled',
};

export const SESSION_STATUS_COLORS = {
  [SESSION_STATUS.ACTIVE]: 'success',
  [SESSION_STATUS.COMPLETED]: 'secondary',
  [SESSION_STATUS.CANCELLED]: 'error',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
};

export const PAYMENT_STATUS_ARRAY = Object.values(PAYMENT_STATUS);

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS.PENDING]: 'Pending',
  [PAYMENT_STATUS.PAID]: 'Paid',
};

export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.PENDING]: 'warning',
  [PAYMENT_STATUS.PAID]: 'success',
};

export const PAYMENT_METHODS = {
  CASH: 'cash',
};

export const PAYMENT_METHODS_ARRAY = Object.values(PAYMENT_METHODS);

export const PAYMENT_METHOD_LABELS = {
  [PAYMENT_METHODS.CASH]: 'Cash',
};

export const SUBSCRIPTION_TYPES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const SUBSCRIPTION_TYPES_ARRAY = Object.values(SUBSCRIPTION_TYPES);

export const SUBSCRIPTION_TYPE_LABELS = {
  [SUBSCRIPTION_TYPES.DAILY]: 'Daily',
  [SUBSCRIPTION_TYPES.WEEKLY]: 'Weekly',
  [SUBSCRIPTION_TYPES.MONTHLY]: 'Monthly',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
};

export const SUBSCRIPTION_STATUS_ARRAY = Object.values(SUBSCRIPTION_STATUS);

export const SUBSCRIPTION_STATUS_LABELS = {
  [SUBSCRIPTION_STATUS.ACTIVE]: 'Active',
  [SUBSCRIPTION_STATUS.EXPIRED]: 'Expired',
  [SUBSCRIPTION_STATUS.CANCELLED]: 'Cancelled',
};

export const SUBSCRIPTION_STATUS_COLORS = {
  [SUBSCRIPTION_STATUS.ACTIVE]: 'success',
  [SUBSCRIPTION_STATUS.EXPIRED]: 'secondary',
  [SUBSCRIPTION_STATUS.CANCELLED]: 'error',
};

export const CAFE_CATEGORIES = {
  BEVERAGE: 'beverage',
  SNACK: 'snack',
  MEAL: 'meal',
  OTHER: 'other',
};

export const CAFE_CATEGORIES_ARRAY = Object.values(CAFE_CATEGORIES);

export const CAFE_CATEGORY_LABELS = {
  [CAFE_CATEGORIES.BEVERAGE]: 'Beverages',
  [CAFE_CATEGORIES.SNACK]: 'Snacks',
  [CAFE_CATEGORIES.MEAL]: 'Meals',
  [CAFE_CATEGORIES.OTHER]: 'Other',
};

export const EXPENSE_TYPES = {
  INVENTORY: 'inventory',
  UTILITIES: 'utilities',
  MAINTENANCE: 'maintenance',
  SUPPLIES: 'supplies',
  SALARY: 'salary',
  RENT: 'rent',
  OTHER: 'other',
};

export const EXPENSE_TYPES_ARRAY = Object.values(EXPENSE_TYPES);

export const EXPENSE_TYPE_LABELS = {
  [EXPENSE_TYPES.INVENTORY]: 'Inventory',
  [EXPENSE_TYPES.UTILITIES]: 'Utilities',
  [EXPENSE_TYPES.MAINTENANCE]: 'Maintenance',
  [EXPENSE_TYPES.SUPPLIES]: 'Supplies',
  [EXPENSE_TYPES.SALARY]: 'Salary',
  [EXPENSE_TYPES.RENT]: 'Rent',
  [EXPENSE_TYPES.OTHER]: 'Other',
};

export const REPORT_TYPES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const REPORT_TYPES_ARRAY = Object.values(REPORT_TYPES);

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPES.DAILY]: 'Daily',
  [REPORT_TYPES.WEEKLY]: 'Weekly',
  [REPORT_TYPES.MONTHLY]: 'Monthly',
};

export const AUDIT_ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  LOGIN: 'login',
  LOGOUT: 'logout',
  VIEW: 'view',
};

export const AUDIT_ACTIONS_ARRAY = Object.values(AUDIT_ACTIONS);

export const AUDIT_ACTION_LABELS = {
  [AUDIT_ACTIONS.CREATE]: 'Create',
  [AUDIT_ACTIONS.UPDATE]: 'Update',
  [AUDIT_ACTIONS.DELETE]: 'Delete',
  [AUDIT_ACTIONS.LOGIN]: 'Login',
  [AUDIT_ACTIONS.LOGOUT]: 'Logout',
  [AUDIT_ACTIONS.VIEW]: 'View',
};

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
};

export const DATE_FORMATS = {
  SHORT: { month: 'short', day: 'numeric', year: 'numeric' },
  LONG: { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' },
  TIME: { hour: 'numeric', minute: '2-digit', hour12: true },
  DATE_TIME: {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  },
};

export const CURRENCY = {
  CODE: 'EGP',
  SYMBOL: 'E£',
  NAME: 'Egyptian Pound',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const STORAGE_KEYS = {
  TOKEN: 'studyspace_token',
  USER: 'studyspace_user',
  THEME: 'studyspace_theme',
};

export const TOAST_DURATION = {
  SHORT: 3000,
  DEFAULT: 4000,
  LONG: 6000,
};

export const VALIDATION = {
  NAME_MIN: 2,
  NAME_MAX: 50,
  PASSWORD_MIN: 8,
  PASSWORD_MAX: 128,
  PHONE_MIN: 10,
  PHONE_MAX: 15,
  DESCRIPTION_MAX: 500,
};

export const TABLE_CONFIG = {
  ROW_HEIGHT: 48,
  HEADER_HEIGHT: 56,
  EMPTY_STATE_HEIGHT: 200,
};
